var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class AlfatronMukn {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'GET VER',
                next: /VER\s*[\d\.]+|Welcome to the/i,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET VER`, /VER\s*([\d\.]+)/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`GET MP hdmiout${key}`, new RegExp(`MP (?:hdmi)?in(\\d+) (?:hdmi)?out${key}`, 'i'), tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SET SW hdmiin${value} hdmiout${key}`, new RegExp(`SW (?:hdmi)?in(\\d+) (?:hdmi)?out${key}`, 'i'), tags);
                return match[1];
            }),
            asyncHandlers: [
                {
                    regExp: /(?:MP|SW) (?:hdmi)?in(\d+) (?:hdmi)?out(\d+)/i,
                    callback: (match) => {
                        const value = match[1];
                        const key = match[2];
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
            ],
        };
        // polling
        this.polls = [
            {
                intervalMs: 5000,
                function: () => __awaiter(this, void 0, void 0, function* () {
                    // Use "GET MP all" to query all the routes and let the async handlers process them.
                    yield this.socket.sendAsync(`GET MP all`, ['poll', 'get.videoMatrixRoutes']);
                }),
            },
        ];
    }
    // phase callbacks
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
AlfatronMukn.driverType = 'socketDriver';
AlfatronMukn.key = '-MluysLKMOwqXPlUzGLg';
AlfatronMukn.baseSocketOptions = {
    sendTerminator: '\r\n',
};
AlfatronMukn.socketOptions = [
    Object.assign(Object.assign({}, AlfatronMukn.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, AlfatronMukn.baseSocketOptions), { port: 4999 }),
];
